export default {
    getReadWidget:   () => '<ma-date-column field="::field" value="::value"></ma-date-column>',
    getLinkWidget:   () => '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>',
    getFilterWidget: () => '<ma-date-field field="::field" value="value"></ma-date-field>',
    getWriteWidget:  () => '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>'
};



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Crud/fieldView/DateTimeFieldView.js